import React, { Fragment, useState } from "react";

const LiveMentorsSearchInput = () => {
  const [noValue, setValue] = useState("");
  return (
    <Fragment>
      <section className="live-hero">
        <form
          method="POST"
          action="/liveonime/mentors"
          className="form-flex-alt"
          onChange={(e) => setValue(e.target.value)}
        >
          <div className="label-input">
            <label htmlFor="" className="labels red">
              Search<i className="fas fa-search red mx-5"></i>
            </label>
            <div className="input-drop-down">
              <div className="search-input-hidden">
                <input
                  className="search-input-style"
                  type="text"
                  name="mentors"
                  placeholder="Enter Mentor Name, Stream, Course or Keywords"
                />
                <button className="search-button background-red" type="submit">
                  <i className="fas fa-search"></i>
                </button>
              </div>
              {noValue && (
                <div className="hero-search-results">
                  <div className="profile-drop-container">
                    <i className="far fa-user-circle fa-2x drop-down-icon red"></i>
                    <p className="drop-down-text">Mentor</p>
                  </div>
                  <div className="profile-drop-container">
                    <i className="fas fa-video fa-lg drop-down-icon red"></i>
                    <p className="drop-down-text">Stream</p>
                  </div>
                  <div className="profile-drop-container">
                    <i className="fas fa-graduation-cap fa-lg drop-down-icon red"></i>
                    <p className="drop-down-text">Course</p>
                  </div>
                  <div className="profile-drop-container">
                    <i className="far fa-user-circle fa-2x drop-down-icon red"></i>
                    <p className="drop-down-text">Mentor</p>
                  </div>
                  <div className="profile-drop-container">
                    <i className="fas fa-video fa-lg drop-down-icon red"></i>
                    <p className="drop-down-text">Stream</p>
                  </div>
                  <div className="profile-drop-container">
                    <i className="fas fa-graduation-cap fa-lg drop-down-icon red"></i>
                    <p className="drop-down-text">Course</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </form>
      </section>
    </Fragment>
  );
};

export default LiveMentorsSearchInput;
